<template>
    <div :class="{
                'repeatable': item.repeat,
                'repeated': item.repeated,
            }">
        <div>
            <h1><span v-if="item.required" class="text-red">* </span>{{ item.title }}</h1>
            <button
                v-if="item.repeat"
                class="btn btn-default btn-secondary mb-0"
                @click="addRepeatableSection">
                {{ $t('Add {section}', {section: item.title}) }}
            </button>
            <button
                v-if="item.repeated"
                class="btn btn-default btn-secondary mb-4"
                @click="deleteRepeatedSection">
                {{ $t('Delete {section}', {section: item.title}) }}
            </button>

            <div v-if="showErrors && hasError" class="error-text mt-2 text-red">
                {{ itemErrors.join(', ') }}
            </div>

        </div>

        <template v-if="!item.repeat">
            <Items
                :items="item.items"
                :errors="errors"
                :response-sets="responseSets"
                :show-errors="showErrors"
            />
        </template>

    </div>
</template>

<script>
    import Items from './Items';

    export default {
        components: { Items },
        props: {
            item: {
                type: Object,
                required: true,
            },
            errors: {
                type: Object,
                required: true,
            },
            showErrors: {
                type: Boolean,
                required: true,
            },
            responseSets: {
                type: Array,
                required: true,
            },
        },
        computed: {
            hasError() {
                return typeof (this.errors[this.item.uuid]) !== 'undefined';
            },
            itemErrors() {
                return this.errors[this.item.uuid];
            },
        },

        methods: {
            addRepeatableSection() {
                this.$store.commit('conduct/addRepeatableSection', {
                    item: this.item.uuid,
                });
            },
            deleteRepeatedSection() {
                this.$store.commit('conduct/deleteRepeatedSection', {
                    item: this.item.uuid,
                });
            },

        },

    };
</script>
